import React from "react";
import PropTypes from "prop-types";

const FooterSection = ({ heading, children, className = "", ...props }) => (
  <div className={`footer-section ${className}`} {...props}>
    <h2 className="footer-section__heading">{heading}</h2>
    <ul className="footer-section__items">{children}</ul>
  </div>
);

FooterSection.propTypes = {
  /**
   * Section heading
   */
  heading: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default FooterSection;
